import React from 'react';
import { ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows } from '../data/salesContent';
export function ComparisonSection() {
  return <section className="w-full bg-ink-900 py-16 sm:py-24" aria-labelledby="comparison-title" style={{
    paddingBottom: "0px"
  }} data-id="element-40" data-mp="3e7txh6ct8bjf">
      <div className="mx-auto max-w-4xl px-5" data-id="element-41" data-mp="34g6abhnadgnr">
        <h2 id="comparison-title" className="text-center font-display text-3xl font-bold text-white sm:text-[2.75rem]" data-id="element-42" data-mp="34feeq6tovixh">
          The Difference — <span className="text-lilac-400" data-id="element-43" data-mp="2vf80uju2wgxs">Managing vs Owning</span>
        </h2>

        <ul className="mt-12 space-y-3" data-id="element-44" data-mp="2vhcfnwtin0cu">
          {comparisonRows.map(row => <li key={row.moment} className="overflow-hidden rounded-2xl border border-white/10 bg-ink-700" data-id="element-45" data-mp="2qgexhk8ia6bc">
              <p className="border-b border-white/10 px-5 py-3 font-display text-lg font-bold text-white" data-id="element-46" data-mp="2limvtyi275ty">
                {row.moment}
              </p>
              <div className="grid sm:grid-cols-2" data-id="element-47" data-mp="jp5rb3p86l3f">
                <div className="flex items-start gap-2.5 px-5 py-4" data-id="element-48" data-mp="jnch5efeliqo">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" strokeWidth={3} aria-hidden="true" data-id="element-49" data-mp="3aebgu6wuuge2" />
                  <span className="text-[15px] leading-relaxed text-muted" data-id="element-50" data-mp="3ei9bo5f5d51b">
                    {row.without}
                  </span>
                </div>
                <div className="flex items-start gap-2.5 border-t border-white/10 bg-success/5 px-5 py-4 sm:border-l sm:border-t-0" data-id="element-51" data-mp="35fi107u3idaq">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-52" data-mp="3t6489ww9ztjo" />
                  <span className="text-[15px] font-medium leading-relaxed text-white" data-id="element-53" data-mp="1yhvnerkwgqo">
                    {row.with}
                  </span>
                </div>
              </div>
            </li>)}
        </ul>

        <p className="mt-8 flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-muted" data-id="element-54" data-mp="3ocj6ruvh4hfq">
          <span className="text-danger" data-id="element-55" data-mp="kpixcak32qdx">Without the Blueprint</span>
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-56" data-mp="krvn39w3251j" />
          <span className="text-success" data-id="element-57" data-mp="ukgdaltljy3o">With the Blueprint</span>
        </p>
      </div>
    </section>;
}